/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { globalColors } from "../../../themes/colors";

export {
  StyledBreadCrumbContainer,
  StyledLink,
  filterContainerStyles,
  selectBaseStyles,
  viewTypographyStyles,
  datePickerStyles,
} from "../classified_discount_records/styles";

export { dropdownMenuProps } from "../perq_report/styles";

export const LABOR_REPORT_COLORS = {
  headerBand: "#f7f7f7",
  totalRow: "#f7f7f7",
  border: "#d9d9d9",
  negative: "#FF0000",
};

const headerCellBase = {
  // Matches the body cells' size/colour so the header reads as part of the same grid.
  color: globalColors.tableData,
  fontSize: "14px",
  borderRight: `1px solid ${LABOR_REPORT_COLORS.border}`,
  "&:last-of-type": { borderRight: 0 },
};

// Sits above the "Business" column — blank, but has to carry the band colour to keep it unbroken.
export const groupSpacerStyles = {
  ...headerCellBase,
  backgroundColor: LABOR_REPORT_COLORS.headerBand,
};

export const groupBandStyles = {
  ...headerCellBase,
  backgroundColor: LABOR_REPORT_COLORS.headerBand,
  textAlign: "center",
};

export const columnHeaderStyles = {
  ...headerCellBase,
  backgroundColor: LABOR_REPORT_COLORS.headerBand,
  whiteSpace: "normal",
  lineHeight: 1.25,
  verticalAlign: "bottom",
};

const rowBase = {
  "& .MuiTableCell-root": {
    borderRight: `1px solid ${LABOR_REPORT_COLORS.border}`,
    "&:last-of-type": { borderRight: 0 },
  },
};

// nth-of-type is repeated because StyledTableRow's own zebra rule targets it and
// would otherwise win over a plain backgroundColor here.
export const totalRowStyles = {
  ...rowBase,
  backgroundColor: LABOR_REPORT_COLORS.totalRow,
  "&:nth-of-type(odd)": { backgroundColor: LABOR_REPORT_COLORS.totalRow },
  "& .MuiTableCell-root": {
    ...rowBase["& .MuiTableCell-root"],
    fontWeight: 600,
  },
};

export const detailRowStyles = {
  ...rowBase,
  backgroundColor: "#ffffff",
  "&:nth-of-type(odd)": { backgroundColor: "#ffffff" },
};

export const negativeCellStyles = {
  color: LABOR_REPORT_COLORS.negative,
  fontWeight: 600,
};

export const groupTotalRowStyles = {
  ...totalRowStyles,
  "& .MuiTableCell-root": {
    ...totalRowStyles["& .MuiTableCell-root"],
    position: "sticky",
    // -1px, not 0: pinned flush, a sub-pixel seam opens at the container edge and the rows
    // underneath show through it. One pixel of overhang closes it. Do not "fix" this to 0.
    bottom: "-1px",
    zIndex: 2,
    backgroundColor: LABOR_REPORT_COLORS.totalRow,
    fontWeight: 700,
    borderTop: `1px solid ${LABOR_REPORT_COLORS.border}`,
    borderBottom: 0,
  },
  "& .MuiTableCell-root:first-of-type": { textAlign: "right" },
  '& [data-negative="true"]': { fontWeight: "inherit" },
};

export const groupTotalLabelStyles = {
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
};
